export default {
    'The two passwords you entered did not match': 'The two passwords you entered did not match',
    'emailCodeSendTip': 'We have sent you a verification code to confirm your email, please log in to your mailbox to check the verification code to complete your password setting.',
    'mobileCodeSendTip': 'We have sent you a verification code,  please go to your mobile phone to check the verification code to complete your password setting.',
    'The verification code has been sent': 'The verification code has been sent',
    'Please enter your correct email address': 'Please enter your correct email address',
    'Please enter your email':'Please enter your email',
    'Please enter your correct mobile': 'Please enter your correct mobile',
    'Please enter your moblie':'Please enter your moblie',
    'Please enter your verification code':'Please enter your verification code',
    'select placeholder': 'Please select you',
    'Please upload your avatar': 'Please upload your profile picture',
    'Please enter your name': 'Please enter your name',
    'Please enter your company name': 'Please enter your company name',
    'Please enter your position': 'Please enter your title',
    'Please enter your current password':'Please enter your current password',
    'Please enter your new password':'Please enter your new password',
    'Please enter your new password again':'Please enter your new password again',
    'Please enter your password':'Please enter your password',
    'The mailbox already exists, please enter again': 'The mailbox already exists, please enter again',
    'current password':"Current password",
    'Please enter your exhibitor code':'Please enter your exhibitor code',
    newPassword: 'New password',
    inputAgain: 'Please enter again',
    newPasswordAgain: 'Please enter the new password again',
    'submit':"Continue",
    'quesSubmit':"Submit",
    'sex':['Mr','lady'],
    'accountInfo':'Registration Information',
    'please click the "login/registration" button to register':`You haven't registered yet. Please click the "login / register"  to register first`,
    'Upload again':"Reupload",
    'del':"Delete",
    'Please enter your company':'Please fill in the company name',
    'Please enter your department':'Please fill in the department',
    'Please enter your id card':'Please input the ID number',
    'Please enter your correct ID number':'The ID number is wrong, please input again',
    'Please select your country':'Please select country & region',
    'Please select your province':'Please select province',
    'Please select your city':'Please select city',
    'Please select your address':'Please fill in the address',
    'Please select your fax':'Please enter your fax number',
    'Please enter your correct fax':'Please enter correct fax number',
    // 'You have registered, you can visit the online exhibition from June 18 to 24 by using this account':'Your registration is successful.  All business functions of Beijing International High-tech Exop is available to use now. ',
    'You have registered, you can visit the online exhibition from June 18 to 24 by using this account':'Your have created your account successfully.  Please feel free to visit Beijing International High-tech Exop.',
    'Confirm Registration': 'Registration Confirmation',
    'Please select your title':'Please select your title',
    'Top':'Back',
    'Next':'Next',
    'area code':'area code',
    'mobileRepeat':'This mobile number has already existed.',
    'Questionnaire':'Questionnaire',
    'Please choose the answer':'Please choose the answer',
    'Please enter the content':'Please enter the content',
    'submit successfully':'submit successfully',
    'Upload':'Upload',
    // 'Pre-registration':'Pre-registration',
    'Pre-registration':'Survey Management',
    'Complete Personal Information':'Complete Personal Information',
    // 'Successful pre-registration':'Your registration information is well received and under review. We will send the result to you by email in 2 hours. Please wait patiently. Any questions, please feel free to contact info@jinhanfair.com.（Working hours：GMT +8 08:30-17:30)',
    'Successful pre-registration': 'Registration Confirmation Your registration is successful.  All business functions of Beijing International High-tech Exop is available to use now. ',
    'Survey Management':'Survey Management'
}